import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../../common/element/Card";
import Heading from "../../../common/element/Heading";
import Circle from "../../../common/element/Iconcircle";
import { Link } from "react-router-dom";
import SweetAlertService from "../../../common/SweetAlert/SweetAlert";
import { forgotPassword, clearForgotPassword } from "../../../redux/auth/authSlice";

function ResetLink(props) {
  const dispatch = useDispatch();
  const [email] = useState(
    JSON.parse(localStorage.getItem("login"))
      ? JSON.parse(localStorage.getItem("login"))
      : ""
  );

  // Get forgot password state from Redux
  const { loading, data, error } = useSelector((state) => state.auth.forgotPassword);

  const handleResendClick = (e) => {
    e.preventDefault();

    if (!email) {
      SweetAlertService.showError({
        title: 'Error!',
        message: 'Email not found. Please go back and enter your email again.',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Dispatch forgot password action with email string directly
    dispatch(forgotPassword(email));
  };

  // Handle success/error with SweetAlert for resend
  useEffect(() => {
    if (data && data.success) {
      SweetAlertService.showSuccess({
        title: 'Success!',
        message: 'Password reset link has been resent to your email.',
        subtitle: 'Check your inbox',
        confirmButtonText: 'OK',
        onConfirm: () => {
          dispatch(clearForgotPassword());
        }
      });
    }

    if (error) {
      SweetAlertService.showError({
        title: 'Error!',
        message: error || 'Failed to resend reset email. Please try again.',
        confirmButtonText: 'OK',
        onConfirm: () => {
          dispatch(clearForgotPassword());
        }
      });
    }
  }, [data, error, dispatch]);

  return (
    <div
      style={{ backgroundColor: `rgb(255, 244, 229)` }}
      className="flex justify-center min-h-screen"
    >
      <div className="min-h-screen justify-center flex py-12 px-6">
        <div className="flex-col items-center justify-center flex">
          <Card className="w-500 rounded-xl block-shadow w-100 mt-2 px-10 py-8">
            <Circle className="bg-[#FFF4E5] border-blue-50 mb-6">
              <img src="/assets/icons-svg/mail.svg" alt="conserve" />
            </Circle>
                                      <h4 className="font-lato font-semibold text-[30px] leading-[38px] text-[#101828] text-wrap lg:text-nowrap text-center">Check your email</h4>

            <p className="font-lato font-medium text-base leading-[1.5] text-center text-[#475467] mb-[28px]">
              We sent a password reset link to <br />
              <span className="font-semibold">{email}</span>
            </p>
            <p className="text-xs text-center">
              Didn't receive the email? &nbsp;
              {!loading ? (
                <button
                  className="text-blue-700 font-semibold hover:text-blue-900 focus:text-blue-700 underline bg-transparent border-none cursor-pointer"
                  onClick={handleResendClick}
                  disabled={loading}
                >
                  Click to resend
                </button>
              ) : (
                <span className="cursor-not-allowed opacity-50 text-xs text-gray-600 font-semibold">
                  Sending...
                </span>
              )}
            </p>
          </Card>
          <div className="mt-8 px-10 w-full text-center">
            <Link
              to="/login"
              className="text-xs text-gray-600 font-semibold hover:text-gray-900 focus:text-gray-600 flex justify-center items-center"
            >
              <img
                src="/assets/icons-svg/arrow-left.svg"
                className="w-5 mr-2"
                alt=""
              />
              Back to log in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetLink;